import React, { useState, useEffect, useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import {
  Container,
  Typography,
  Divider,
  Button,
  Grid,
  CircularProgress,
} from '@material-ui/core';
import { Form } from '@unform/web';
import { differenceInMinutes } from 'date-fns';
import { useStyles } from './styles';
import { generateId } from './utils';
import SurveilanceTopForm from '../../components/SurveilanceTopForm';
import {
  ViaDetails,
  Coordinator,
  Agent,
  CarsMoto,
  MissionDetails,
  Tests,
  Refusa,
  Positive,
  NoticeDetails,
  InfractionsVehicles,
  DRV,
  Comment,
  SurveillanceMission,
  SurveilanceType,
} from '../../@types/surveilanceTypes';
import CoordinatorFormGroup from '../../components/CoordinatorFormGroup';
import AgentFormGroup from '../../components/AgentFormGroup';
import CarsMotorFormGroup from '../../components/CarsMotoFormGroup';
import MissionDetailsForm from '../../components/MissionDetailsForm';
import TestsPeformedFormGroup from '../../components/TestsPeformedFormGroup';
import RefusalFormGroup from '../../components/RefusalFormGroup';
import PositiveFormGroup from '../../components/PositiveFormGroup';
import NoticeFormGroup from '../../components/NoticesFormGroup';
import InfrVehiclesFormGroup from '../../components/InfrVehiclesFormGroup';
import DRVsNumberFormGroup from '../../components/DRVsNumberFormGroup';
import CommentsFormGroup from '../../components/CommentFormGroup';
import ShowSnackbar, { SetSnackbarType } from '../../components/SnackBar';
import DialogWarningMessage from '../../components/DialogWarningMessage';
// import api from '../../services/api';
import DialogConfirm from '../../components/DialogConfirm';
import DialogWarnActions, { DialogActionType } from '../../components/DialogWarnActions';
import { deleteSurveillanceById, fetchSurveillanceById, updateSurveillance } from '../../actions/surveillanceActions';
import { set } from 'lodash';
import { ViaDetailsObject, CoordinatorObject, AgentObject, CarsMotoObject, NoticeDetailsObject, DRVObject, Coordinates, PeriodType } from '../../@types/surveilanceTypes';
import { RequestSurveillancePostType as FormData, SurveillanceMission as SurveilanceMissionType } from '../../@types/surveilanceTypes';
import Colors from '../../components/Colors';


interface ParamsType {
  pathId: string;
}

const initialSurveilanceMission: SurveilanceMissionType = {
  'Tipo da Missão': 'Outros',
  'Descrição do tipo da Missão': '',
  'Foco da Missão': 'Outro',
  'Descrição do Foco da Missão': '',
  _localId: generateId(),
};

const initialMissionDetails: MissionDetails = {
  'Equipe de Apoio': 'Outro',
  'Quantidade de Veículos com mais de 3 Rodas Abordados': '0',
  'Quantidade de Motocicletas, Ciclomotores e Triciclos Abordados': '0',
  'Total de Veículos Abordados': '0',
  'Quantidade de Veículos de 2 ou 3 Rodas Removidos (Pela AMC ou pelo Proprietário)': '0',
  'Quantidade de Veículos 4+ Rodas Removidos (Pela AMC ou pelo Proprietário)': '0',
  'Quantidade de CRLVs Recolhidos': '0',
  'Quantidade de Habilitações Recolhidas': '0',
  _localId: generateId(),
};

const initialRefusalAmount: Refusa = {
  'Total de Recusas Masculino': '0',
  'Total de Recusas Feminino': '0',
  _localId: generateId(),
};

const initialPositiveAmount: Positive = {
  'Total de Positivos Masculino': '0',
  'Total de Positivos Feminino': '0',
  _localId: generateId(),
};

const initialTestAmount: Tests = {
  Passivos: '0',
  Alcoolsensor: '0',
  _localId: generateId(),
};

const initialInfractionsVehicles: InfractionsVehicles = {
  'Total de Infrações': '0',
  'Total de Veículos Autuados': '0',
  _localId: generateId(),
};

const initialComments: Comment = {
  Observações: '',
  _localId: generateId(),
};

const initialPeriod: PeriodType = {
  occuredFrom: '',
  occuredTo: '',
};

const initialPostObj: FormData = {
  data: {
    driverSurveillanceMission: initialSurveilanceMission,
    missionCoordinator: [],
    agentRegisters: [],
    carsOrMotocycles: [],
    surveillanceMissionDetails: initialMissionDetails,
    testsPerformedOrStartedCount: initialTestAmount,
    refusalAmount: initialRefusalAmount,
    positiveAmount: initialPositiveAmount,
    noticesDetails: [],
    infractionsAndNoticedVehiclesAmount: initialInfractionsVehicles,
    DRVsNumber: [],
    comments: initialComments,
  },
  geom: '',
  schema: '',
  occurred_from: '',
  occurred_to: '',
  location_text: '',
};

const UpdateSurveilance: React.FC = () => {
  const classes = useStyles();
  const [period, setPeriod] = useState<PeriodType>(initialPeriod);
  const [surveilanceMission, setSurveilanceMission] = useState<SurveilanceMissionType>(
    initialSurveilanceMission,
  );
  const [latLng, setLatLng] = useState<Coordinates>({ lat: 0, lng: 0 });
  const [requiredFields, setRequiredFields] = useState<string[]>([]);
  const [viaDetails, setViaDetails] = useState<ViaDetailsObject[]>([]);
  const [locationText, setLocationText] = useState<string>('');
  const [coordinators, setCoordinators] = useState<CoordinatorObject[]>([]);
  const [agents, setAgents] = useState<AgentObject[]>([]);
  const [carsMotors, setCarsMotors] = useState<CarsMotoObject[]>([]);
  const [missionDetails, setMissionDetails] = useState<MissionDetails>(
    initialMissionDetails,
  );
  const [testsAmount, setTestsAmount] = useState<Tests>(initialTestAmount);
  const [refusalAmount, setRefusalAmount] = useState<Refusa>(initialRefusalAmount);
  const [positiveAmount, setPositiveAmount] = useState<Positive>(initialPositiveAmount);
  const [noticeDetails, setNoticeDetails] = useState<NoticeDetailsObject[]>([]);
  const [infractionsVehicles, setInfractionsVehicles] = useState<InfractionsVehicles>(
    initialInfractionsVehicles,
  );
  const [DRVsNumber, setDRVsNumber] = useState<DRVObject[]>([]);
  const [comments, setComments] = useState<Comment>(initialComments);
  const [loading, setLoading] = useState<boolean>(true);
  const [snackBar, setSnackbar] = useState<SetSnackbarType>({ open: false, message: '' });
  const [warnMessages, setWarnMessages] = useState<{ key: string; message: string }[]>(
    [],
  );
  const [openDialogWarn, setOpenDialogWarns] = useState<boolean>(false);
  const [openDialogConfirm, setDialogConfirm] = useState<boolean>(false);
  const [dialogAction, setDialogAction] = useState<DialogActionType>({
    open: false,
    title: '',
    actions: [],
  });

  const { pathId } = useParams<ParamsType>();

  const authHeader = useMemo(() => {
    return { Authorization: `Token ${localStorage.getItem('auth')}` };
  }, []);

  const history = useHistory();
  const navigate = (path: string) => {
    history.push(path);
  };

  const mountStates = (data: SurveilanceType) => {
    setLatLng({
      lat: data.geom.coordinates[1],
      lng: data.geom.coordinates[0],
    });
    setPeriod({
      occuredFrom: data.occurred_from,
      occuredTo: data.occurred_to,
    });

    setSurveilanceMission(data.data.driverSurveillanceMission);
    setViaDetails(data.data.viaDetails as ViaDetailsObject[]);
    setLocationText(data.location_text);
    setCoordinators(data.data.missionCoordinator as CoordinatorObject[]);
    setAgents(data.data.agentRegisters as AgentObject[]);
    setCarsMotors(data.data.carsOrMotocycles as CarsMotoObject[]);
    setMissionDetails(data.data.surveillanceMissionDetails);
    setTestsAmount(data.data.testsPerformedOrStartedCount);
    setRefusalAmount(data.data.refusalAmount);
    setPositiveAmount(data.data.positiveAmount);
    setNoticeDetails(data.data.noticesDetails as NoticeDetailsObject[]);
    setInfractionsVehicles(data.data.infractionsAndNoticedVehiclesAmount);
    setDRVsNumber(data.data.DRVsNumber as DRVObject[]);
    setComments(data.data.comments);
  };

  const postRecord = async (record: FormData) => {
    setLoading(true);
    try {
      const { data } = await updateSurveillance(pathId, record);
      mountStates(data);
      setWarnMessages([]);

      setDialogAction({
        open: true,
        title: 'Missão de Fiscalização atualizada com sucesso!',
        actions: [
          {
            btnText: 'Registros',
            color: 'primary',
            action: () => navigate('/registros/fiscalizacoes'),
          },
          {
            btnText: 'Mapa',
            color: 'primary',
            action: () => navigate('/mapa/fiscalizacoes'),
          },
          {
            btnText: 'Exibir',
            color: 'primary',
            action: () => navigate(`/registro/fiscalizacao/${pathId}`),
          },
        ],
      });
    } catch (error) {
      setSnackbar({
        open: true,
        message: 'Erro ao atualizar a Missão de Fiscalização.',
      });
    } finally{
      setLoading(false);
    }
  };

  const deleteRecords = async (id: string) => {
    setLoading(true);
    try {
      await deleteSurveillanceById(id);

      setDialogAction({
        open: true,
        title: 'Missão de Fiscalização removida com sucesso!',
        actions: [
          {
            btnText: 'Registros',
            color: 'primary',
            action: () => navigate('/registros/fiscalizacoes'),
          },
          {
            btnText: 'Mapa',
            color: 'primary',
            action: () => navigate('/mapa/fiscalizacoes'),
          },
          {
            btnText: 'Nova Intervenção',
            color: 'primary',
            action: () => navigate('/add/fiscalizacao'),
          },
        ],
      });
    } catch (error) {
      setSnackbar({ open: true, message: 'Erro ao remover a missão de fiscalização.' });
    } finally {
      setLoading(false);
    }
  };

  const validateFields = (fieldsData: FormData) => {
    setRequiredFields([]);
    const { data } = fieldsData;
    const formError: { key: string; message: string }[] = [];

    const diffMin = differenceInMinutes(
      new Date(period.occuredTo),
      new Date(period.occuredFrom),
    );
    const diffHour = diffMin / 60;

    if (latLng.lat === 0 || latLng.lng === 0) {
      formError.push({
        key: 'missionLocation',
        message: 'Informe a localização da missão.',
      });
    }

    if (diffHour <= 0) {
      formError.push({ key: 'missionDate', message: 'A missão não pode durar 0 horas.' });
    } else if (diffHour > 23) {
      formError.push({
        key: 'missionDate',
        message: 'A missão não pode durar mais que 23 horas.',
      });
    }

    if (data.missionCoordinator.length === 0) {
      formError.push({
        key: 'missionCoord',
        message: 'A missão de fiscalização precisa ter pelo menos 1 coordenador.',
      });
    }

    if (data.agentRegisters.length === 0) {
      formError.push({
        key: 'missionAgent',
        message: 'A missão de fiscalização precisa ter pelo menos 1 agente.',
      });
    }

    const totalTests =
      Number(data.testsPerformedOrStartedCount.Alcoolsensor) +
      Number(data.testsPerformedOrStartedCount.Passivos);

    const refusalTests =
      Number(data.refusalAmount['Total de Recusas Feminino']) +
      Number(data.refusalAmount['Total de Recusas Masculino']);

    const totalPositive =
      Number(data.positiveAmount['Total de Positivos Feminino']) +
      Number(data.positiveAmount['Total de Positivos Masculino']);

    if (totalTests < refusalTests) {
      formError.push({
        key: 'testsRefusal',
        message:
          'A quantidade total de testes não pode ser menor que o total de testes recusados.',
      });
    }

    if (totalTests < totalPositive) {
      formError.push({
        key: 'testsPositive',
        message:
          'A quantidade total de testes não pode ser menor que o total de testes positivos.',
      });
    }

    const removedVehicles =
      Number(
        data.surveillanceMissionDetails[
          'Quantidade de Veículos 4+ Rodas Removidos (Pela AMC ou pelo Proprietário)'
        ],
      ) +
      Number(
        data.surveillanceMissionDetails[
          'Quantidade de Veículos de 2 ou 3 Rodas Removidos (Pela AMC ou pelo Proprietário)'
        ],
      );

    if (
      Number(data.surveillanceMissionDetails['Total de Veículos Abordados']) <
      removedVehicles
    ) {
      formError.push({
        key: 'removedVehicles',
        message:
          'O total de veículos removidos não pode ser maior que o total de veículos abordados',
      });
    }
    if (formError.length === 0) {
      postRecord(fieldsData);
      window.scrollTo(0, 0);
      return;
    }

    setWarnMessages(formError);
    setOpenDialogWarns(true);
  };

  const handleSubmit = async () => {
    const bodyForm: FormData = initialPostObj;
    bodyForm.geom = `POINT(${latLng.lng} ${latLng.lat})`;
    bodyForm.occurred_from = period.occuredFrom;
    bodyForm.occurred_to = period.occuredTo;
    bodyForm.data.driverSurveillanceMission = surveilanceMission;
    bodyForm.data.missionCoordinator = coordinators;
    bodyForm.data.agentRegisters = agents;
    bodyForm.data.carsOrMotocycles = carsMotors;
    bodyForm.data.surveillanceMissionDetails = missionDetails;
    bodyForm.data.testsPerformedOrStartedCount = testsAmount;
    bodyForm.data.refusalAmount = refusalAmount;
    bodyForm.data.positiveAmount = positiveAmount;
    bodyForm.data.noticesDetails = noticeDetails;
    bodyForm.data.infractionsAndNoticedVehiclesAmount = infractionsVehicles;
    bodyForm.data.DRVsNumber = DRVsNumber;
    bodyForm.data.comments = comments;
    bodyForm.location_text = locationText;
    bodyForm.schema = `${process.env.REACT_APP_SURVEILLANCE_SCHEMA_ID}`;

    validateFields(bodyForm);
  };

  useEffect(() => {
    setLoading(true);
    async function fetchSurveilnce(id: string) {
      try {
        const { data } = await fetchSurveillanceById(id);
        console.log(data);
        
        mountStates(data);
      } catch (error) { 
        setDialogAction({
          open: true,
          title: 'Não foi possível encontrar a Missão de Fiscalização',
          actions: [
            {
              btnText: 'Registros',
              color: 'primary',
              action: () => navigate('/registros/fiscalizacoes'),
            },
            {
              btnText: 'Mapa',
              color: 'primary',
              action: () => navigate('/mapa/fiscalizacoes'),
            },
            {
              btnText: 'Nova Intervenção',
              color: 'primary',
              action: () => navigate('/add/fiscalizacao'),
            },
          ],
        });
      } finally {        
        setLoading(false);
      }
    }
    pathId
      ? fetchSurveilnce(pathId)
      : setSnackbar({
          open: true,
          message: 'Não foi possível encontrar a missão de fiscalização.',
        });
  }, [pathId, authHeader]);

  return (
    <Container className={classes.root}>
      <Typography variant="h5">Edição dos Detalhes da Missão de Fiscalização</Typography>
      <Divider />
      <Form className={classes.formGroup} autoComplete="off" onSubmit={handleSubmit}>
        <Grid container xs={12}>
          <Grid item xs={12} md={10}>
            <SurveilanceTopForm
              surveilanceMission={surveilanceMission}
              setSurveilanceMission={setSurveilanceMission}
              setLatLng={setLatLng}
              latlng={latLng}
              period={period}
              setPeriod={setPeriod}
              formErrors={warnMessages}
              setFormErrors={setWarnMessages}
              locationText={locationText}
              setLocationText={setLocationText}
            />
            <Grid item xs={12} style={{ margin: '5px 0' }}>
              <MissionDetailsForm
                missionDetails={missionDetails}
                setMissioDetails={setMissionDetails}
                formErrors={warnMessages}
              />
            </Grid>

            <Grid item xs={12} style={{ margin: '5px 0' }}>
              <CoordinatorFormGroup
                coordinators={coordinators}
                setCoordinators={setCoordinators}
                formErrors={warnMessages}
                setFormErrors={setWarnMessages}
              />
            </Grid>
            <Grid item xs={12} style={{ margin: '5px 0' }}>
              <TestsPeformedFormGroup
                testsAmount={testsAmount}
                setTestsAmount={setTestsAmount}
                formErrors={warnMessages}
              />
            </Grid>
            <Grid item xs={12} style={{ margin: '5px 0' }}>
              <RefusalFormGroup
                refusalAmount={refusalAmount}
                setRefusalAmount={setRefusalAmount}
                formErrors={warnMessages}
              />
            </Grid>
            <Grid item xs={12} style={{ margin: '5px 0' }}>
              <PositiveFormGroup
                positiveAmount={positiveAmount}
                setPositiveAmount={setPositiveAmount}
                formErrors={warnMessages}
              />
            </Grid>
            <Grid item xs={12} style={{ margin: '5px 0' }}>
              <NoticeFormGroup
                noticeDetails={noticeDetails}
                setNoticeDetails={setNoticeDetails}
              />
            </Grid>
            <Grid item xs={12} style={{ margin: '5px 0' }}>
              <InfrVehiclesFormGroup
                infractionsVehicles={infractionsVehicles}
                setInfractionsVehicles={setInfractionsVehicles}
              />
            </Grid>
            <Grid item xs={12} style={{ margin: '5px 0' }}>
              <DRVsNumberFormGroup
                DRVs={DRVsNumber}
                setDRVs={setDRVsNumber}
                requiredFields={requiredFields}
              />
            </Grid>
            <Grid item xs={12} style={{ margin: '5px 0' }}>
              <AgentFormGroup
                agents={agents}
                setAgents={setAgents}
                formErrors={warnMessages}
                setFormErrors={setWarnMessages}
              />
            </Grid>
            <Grid item xs={12} style={{ margin: '5px 0' }}>
              <CarsMotorFormGroup
                carsMotors={carsMotors}
                setCarsMotors={setCarsMotors}
                requiredFields={requiredFields}
              />
            </Grid>
            <Grid item xs={12} style={{ margin: '5px 0' }}>
              <CommentsFormGroup comments={comments} setComments={setComments} />
            </Grid>
          </Grid>
          <Grid>
            <div className={classes.buttonsContainer}>
              <div className={classes.buttonWrapper}>
                <Button
                  className={classes.buttons}
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={loading}
                  style={{ backgroundColor: Colors.main }}
                >
                  Atualizar Fiscalização
                </Button>
                {loading && (
                  <CircularProgress size={24} className={classes.buttonProgress} />
                )}
              </div>
              <div className={classes.buttonWrapper}>
                <Button
                  className={classes.buttons}
                  color="default"
                  onClick={() => setDialogConfirm(true)}
                  disabled={loading}
                  style={{ backgroundColor: '#C59054', color: 'white' }}
                >
                  Excluir Fiscalização
                </Button>
                {loading && (
                  <CircularProgress
                    size={24}
                    color="secondary"
                    className={classes.buttonProgress}
                  />
                )}
              </div>
              <div className={classes.buttonWrapper}>
                <Button
                  className={classes.buttons}
                  variant="outlined"
                  color="secondary"
                  onClick={() => navigate('/mapa/fiscalizacoes')}
                  disabled={loading}
                  style={{ backgroundColor: 'white' }}
                >
                  Cancelar
                </Button>
                {loading && (
                  <CircularProgress
                    size={24}
                    color="secondary"
                    className={classes.buttonProgress}
                  />
                )}
              </div>
            </div>
          </Grid>
        </Grid>
      </Form>
      <ShowSnackbar
        open={snackBar.open}
        message={snackBar.message}
        setSnackbar={setSnackbar}
      />
      <DialogWarningMessage
        open={openDialogWarn}
        title="Algumas informações precisam de atenção."
        messages={warnMessages}
        setOpen={setOpenDialogWarns}
      />
      <DialogConfirm
        open={openDialogConfirm}
        title="Apagar Missão de Fiscalização?"
        message="Voce está prestes a apagar essa missão de fiscalização. Essa operação não pode ser desfeita. Você deseja confirmar essa ação?"
        setOpen={setDialogConfirm}
        onConfirm={() => deleteRecords(pathId)}
      />
      <DialogWarnActions dialogActions={dialogAction} setDialog={setDialogAction} />
    </Container>
  );
};

export default UpdateSurveilance;
